import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Loadr from "Common/Components/Loader";
import { Search, SlidersHorizontal } from "lucide-react";
import filterDataBySearch from "Common/filterDataBySearch";
import { ToastContainer } from "react-toastify";
import { usePlayers } from "./usePlayers";

const Customers = () => {
  const { players, isLoading } = usePlayers();
  console.log("players", players);
  const [users, setUser] = useState<any>([]);

  useEffect(() => {
    setUser(players);
  }, [players]);

  //

  // Search Data
  const filterSearchData = (e: any) => {
    const search = e.target.value;
    const keysToSearch = ["name", "designation", "location", "email", "status"];
    filterDataBySearch(players, search, keysToSearch, setUser);
  };

  // columns

  const columns = useMemo(
    () => [
      {
        header: "Phone Number",
        accessorKey: "phoneNumber",
        enableColumnFilter: false,
      },
      {
        header: "Email",
        accessorKey: "email",
        enableColumnFilter: false,
      },
      {
        header: "Name and Image",
        accessorKey: "displayName",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center size-10 font-medium rounded-full shrink-0 bg-slate-200 text-slate-800 dark:text-zink-50 dark:bg-zink-600">
              {cell.row.original?.image && (
                <img
                  src={cell.row.original.image}
                  alt="user"
                  className="rounded-full"
                />
              )}
            </div>
            <div className="grow">
              <h6 className="mb-1">
                <Link to="#!" className="name">
                  {cell.getValue()}
                </Link>
              </h6>
            </div>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb title="Users" pageTitle="Users" />
      {isLoading && <Loadr />}

      <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-12">
        <div className="xl:col-span-12">
          <div className="card" id="usersTable">
            <div className="card-body">
              {users && users.length > 0 ? (
                <TableContainer
                  isPagination={true}
                  columns={columns || []}
                  data={users || []}
                  customPageSize={10}
                  divclassName="mt-5 overflow-x-auto"
                  tableclassName="w-full whitespace-nowrap"
                  theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
                  thclassName="px-3.5 py-2.5 font-semibold text-slate-500 border-b border-slate-200 dark:border-zink-500 dark:text-zink-200"
                  tdclassName="px-3.5 py-2.5 border-y border-slate-200 dark:border-zink-500"
                  PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
                />
              ) : (
                <div className="noresult">
                  <div className="py-6 text-center">
                    <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
                    <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                    <p className="mb-0 text-slate-500 dark:text-zink-200">
                      We've searched more than 199+ users We did not find any
                      users for you search.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Customers;
